import { SIDE_NAV_LIGHT, NAV_TYPE_TOP, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Shipping';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const API_MEDIA_URL = env.API_MEDIA_URL;
export const API_CARS_LOGO_URL = env.API_ENDPOINT_URL + 'static/logo/';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';


export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_TOP,
	topNavColor: '#606943',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
};
